export default __webpack_public_path__ + "static/media/os_img.4ef15323.png";